import axios from "axios";
import { LocalUser } from "./UploadFile";
import { getValidToken } from "./authUtils";
export interface UploadedDocument {
  id: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  s3Key: string;
  s3Url: string;
  documentContext: string;
  documentType: string;
  documentTypeId: string;
  companyId: string;
  uploadedBy: string;
  description: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  presignedUrl: string;
  file?: File;
}

interface FetchDocumentsParams {
  documentContext: string;
  documentTypeId: string;
  documentType?: string;
}

export const fetchDocuments = async ({
  documentContext,
  documentTypeId,
  documentType,
}: FetchDocumentsParams): Promise<UploadedDocument[]> => {
  const token = await getValidToken();

  const url = documentType
    ? `${process.env.REACT_APP_API_HOST}documents/${documentContext}/${documentTypeId}?documentType=${documentType}`
    : `${process.env.REACT_APP_API_HOST}documents/${documentContext}/${documentTypeId}`;

  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.data?.isSuccess) {
    throw new Error("Failed to fetch documents");
  }

  return response.data.data;
};
